import { render, staticRenderFns } from "./ManageCourseGroup.vue?vue&type=template&id=6c1b8248"
import script from "./ManageCourseGroup.vue?vue&type=script&lang=ts"
export * from "./ManageCourseGroup.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports